import React from 'react';
import { useTheme } from 'styled-components';

export const UploadingArrowSvg = (props) => {
  const { width = 14, height = 14, color = '#1DBD6B', ...rest } = props;
  const theme = useTheme();

  return (  
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 14 14"
      {...rest}
    >
      <path
        fill={color}
        d="M10.038 0C12.41 0 14 1.666 14 4.144v5.72C14 12.333 12.41 14 10.038 14h-6.07C1.597 14 0 12.334 0 9.863v-5.72C0 1.667 1.596 0 3.969 0zM7.371 3.767a.54.54 0 0 0-.742 0L4.004 6.405a.53.53 0 0 0 0 .742c.21.203.539.203.749 0l1.722-1.736v4.445a.525.525 0 1 0 1.05 0V5.411l1.729 1.736a.54.54 0 0 0 .371.155.55.55 0 0 0 .371-.155.53.53 0 0 0 0-.742z"
      ></path>
    </svg>
  );
}

